import ListAlt from "@material-ui/icons/ListAlt";
import branchIcon from "../../../assets/img/hub.png";
import loanIcon from "../../../assets/img/signing.png";
import stateIcon from "../../../assets/img/museum.png";
import roleIcon from "../../../assets/img/user.png";
import structureIcon from "../../../assets/img/structure.png";
import hierarchyIcon from "../../../assets/img/diagram.png";
import pincodeIcon from "../../../assets/img/location.png";
import userIcon from "../../../assets/img/add-user.png";
import Lender from "../../../assets/img/debt.png";
import Profile from "../../../assets/img/profile.png";
import Relationship from "../../../assets/img/relationship.png";
import Discrepancy from "../../../assets/img/discrepancy.png";
import { masterNames } from "assets/properties/properties";
const PersonalLoanSidebarLinks = [
    {
      name: masterNames?.masterList,
      icon: ListAlt,
      children: [
  {
    name: masterNames?.branchesMaster,
    code: "BRANCHES",
    url: "/coreservice/branches",
    icon: branchIcon,
  },
  {
    name: masterNames?.pincodesMaster,
    code: "PINCODES",
    url: "/coreservice/pincodes",
    icon: pincodeIcon,
  },
  {
    name: masterNames?.loanSchemeMaster,
    code: "LOANSCHEME",
    url: "/coreservice/loanScheme",
    icon: loanIcon,
  },
  {
    name: masterNames?.inviteUserMaster,
    code: "INVITEUSER",
    url: "/coreservice/user-roles",
    icon: userIcon,
  },
  {
    name: masterNames?.stateMaster,
    code: "STATE",
    url: "/coreservice/state",
    icon: stateIcon,
  },
  {
    name:masterNames?.roleMaster,
    code:"ROLE",
    url: "/coreservice/roles",
    icon: roleIcon,
  },
  {
    name:masterNames?.designationMaster,
    code:"DESIGNATION",
    url: "/coreservice/designation",
    icon: roleIcon,
  },
  {
    name: masterNames?.structureMaster,
    code: "STRUCTURE",
    url: "/coreservice/structure",
    icon: structureIcon,
  },
  {
    name: masterNames?.hierarchyMaster,
    code: "HIERARCHY",
    url: "/coreservice/hierarchy",
    icon: hierarchyIcon,
  },
  {
    name: masterNames?.relationshipMaster,
    code: "RELATIONSHIP",
    url: "/coreservice/relationship",
    icon: Relationship,
  },
  {
    name: masterNames?.negativeProfileMaster,
    code: "NEGATIVEPROFILE",
    url: "/coreservice/DueDiligence",
    icon: Profile,
  },
  {
    name: masterNames?.thirdPartyMaster,
    code: "THIRDPARTY",
    url: "/coreservice/ThirdParty",
    icon: Discrepancy,
  },
  {
    name: masterNames?.glHeadMaster,
    code: "GLHEAD",
    url: "/coreservice/GLHead",
    icon: Discrepancy,
  },
  {
    name: masterNames?.lendingMaster,
    code: "LENDING_PARTNER",
    url: "/coreservice/lendingpartner",
    icon: Lender,
  },
 
      ],
    },
  ];
  export default PersonalLoanSidebarLinks;